import { render, staticRenderFns } from "./ProfesionalApprovalHeatmap.vue?vue&type=template&id=90dec48a&scoped=true&"
import script from "./ProfesionalApprovalHeatmap.vue?vue&type=script&lang=js&"
export * from "./ProfesionalApprovalHeatmap.vue?vue&type=script&lang=js&"
import style0 from "./ProfesionalApprovalHeatmap.vue?vue&type=style&index=0&id=90dec48a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90dec48a",
  null
  
)

export default component.exports